export enum SORT_SLUG {
  ASC = 'ASC',
  DESC = 'DESC',
}
